module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0004.jpg?v=469befb8";